import { Stack } from '@mui/material'
import React, { useState } from 'react'
import { useTheme } from '@mui/material/styles'
import Iconify from './Iconify'
import { Avatar } from './Avatar'

type Props = {
  url?: string
  name?: string
  size?: number
  onClick: () => void
}

export const AvatarProfile = ({ url, name, size = 140, onClick }: Props) => {
  const { palette } = useTheme()
  const [show, setShow] = useState(false)
  const showAction = () => setShow(true)
  const hideAction = () => setShow(false)

  return (
    <Stack width={size} height={size} onMouseEnter={showAction} onMouseLeave={hideAction}>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto', gridTemplateRows: size }}>
        <div style={{ gridRow: 1, gridColumn: '1/2', borderRadius: 100, zIndex: 1 }}>
          <Avatar imagePath={url} name={name} size={size} />
        </div>
        {show &&
            <div
              onClick={onClick}
              style={{
                backgroundColor: palette.grey[100],
                opacity: 0.7,
                gridRow: 1,
                gridColumn: '1/2',
                borderRadius: 100,
                color: 'red',
                cursor: 'pointer',
                zIndex: 2
              }}>
              <Stack
                width={size}
                height={size}
                justifyContent="center"
                alignItems="center">
                <Iconify icon="mdi:camera" style={{ width: 46, height: 46 }} color={palette.grey[800]}/>
              </Stack>
            </div>}
      </div>
    </Stack>
  )
}
